import { Component } from '@angular/core';
import { AuthPromptService } from '../../auth/auth-prompt.service';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {
  constructor(private readonly authPromptService: AuthPromptService) {}

  promptLogin(): void {
    this.authPromptService.promptLogin();
  }
}
